import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { SubmitHandler } from 'react-hook-form'
import {
    CreateCentroCustoOutput,
    CreateCentroCustoSchema,
    centroCusto,
} from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import { FormCentroCusto } from '../forms/FormCentroCusto'

export default function AdicionarCentroCusto() {
    const { mutateAsync, isLoading } = centroCusto.mutations.useCreate({
        invalidateQuery: true,
    })
    const empresaId = useStore(state => state.companyId)

    const handleSubmit: SubmitHandler<CreateCentroCustoOutput> = ({
        predecessorId,
        ...data
    }) => {
        const payload = predecessorId
            ? { ...data, empresaId, predecessorId }
            : { ...data, empresaId, predecessorId: null }

        return mutateAsync(payload, {
            onSuccess: () => {
                toast.success('Centro de custo adicionado com sucesso!')
            },
            onError: err => {
                toast.error(err.message)
            },
        })
    }

    return (
        <Dialog.Root
            loading={isLoading}
            onSubmit={handleSubmit}
            schema={CreateCentroCustoSchema}
            height="auto"
            defaultValues={{
                predecessorId: 0,
                empresaId,
            }}
            open={hasPermission(['create', 'CentrosDeCusto'])}
        >
            <Dialog.Title>Adicionar centro de custo</Dialog.Title>
            <Dialog.Content dividers>
                <FormCentroCusto />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
